import EventPostcardAssetManager from '../../Elements/Windows/eventPostcard/EventPostcardAssetManager';
import { FORTUNE_COOLDOWN_KEY } from './dataTracking/fortuneCookie/FortuneCookieDataManager';

export default class OMT_Cheats {
  /**
   * Adjusts which package of the given shop deals are shown
   * @param {number} day
   */
  static adjustShopDeal(day) {
    if (isNaN(parseInt(day))) { console.log('[CHEAT] Invalid number for argument'); return; } // eslint-disable-line no-restricted-globals
    if (!G.saveState.sessionData.shopSeed || day === 0) { G.saveState.initNewShopSeed(); }
    G.saveState.sessionData.shopSeed += day;
    console.log('[CHEAT] Shop packages are adjusted');
  }

  /**
   * Shows specific shop packages for the special deal.
   * Currently known types are 'first', and 'special', and valentine keys
   * @param {string} type
   */
  static showSpecialDeals(type) {
    if (!type) {
      G.saveState.sessionData.shopSpecialType = null;
    } else {
      G.saveState.sessionData.shopSpecialType = type;
    }
    console.log(`[CHEAT] Shop will now display packages of type ${type}`);
  }

  static completeTreasureHunt() {
    for (let i = 0; i < 60; i++) {
      const { treasureHuntMgr } = G.TreasureHunt;
      treasureHuntMgr.collectGem();
    }
    game.state.getCurrentState().onBoardDeconstructed();
  }

  /**
   * Activates the helpers on the next turn.
   */
  static activateHelpers() {
    if (game.state.current === 'Game') {
      G.lvl.activateHelpersOverride = true;
      console.log('Helpers will show up on the next turn');
    } else {
      console.log('This cheat can only be used in a level.');
    }
  }

  /**
   * Forcefully activates the eventPostcard event
  */
  static activateEventPostcard(start, end) {
    let range = null;
    const startIsGiven = start !== undefined;
    const endIsGiven = end !== undefined;
    if (startIsGiven || endIsGiven) {
      let featureStart = 0;
      let featureEnd = Infinity;

      if (startIsGiven) {
        featureStart = start;
      }
      if (endIsGiven) {
        featureEnd = end;
      }

      range = {
        start: featureStart,
        end: featureEnd,
      };
    }

    G.featureUnlock.eventPostcard = {
      enabled: true,
      range,
    };
    EventPostcardAssetManager.loadAssets();
  }

  /**
   * Activates the fortune cookie event by replacing the active days
   * 0 = Sunday, 6 = Saturday
   * Also removes the timeout cooldown
   * @param {Array<number>} daysActive
   */
  static activateFortuneCookie(daysActive) {
    G.featureUnlock.fortuneCookie.activeDays = daysActive;
    if (G.saveState.getUserCooldownRemaining(FORTUNE_COOLDOWN_KEY.COOLDOWN, '') > 0) {
      G.saveState.setUserCooldown(FORTUNE_COOLDOWN_KEY.COOLDOWN, '', 0, true);
    }
    G.saveState.fortuneCookie_initData();
    console.log('[CHEAT] Fortune Cookie activated for the given days');
  }

  /**
   * go to a specific level
   * @param {number} lvl level #
   */
  static goToLevel(lvl) {
    G.saveState.data.levels = [];
    G.saveState.data.finishedTutorials = [];
    G.saveState.data.boosters = [null, 30, 30, 30, 30, 30, 30, 30, 30];
    for (let i = 0; i < lvl; i++) {
      G.saveState.data.levels.push(3);
    }
    // FIXME: the arguments are not valid
    const levelData = {
      lvlIndex: lvl - 1,
      debugMode: true,
    };
    game.state.start('Game', true, false, levelData);
  }

  /**
   * win the current board
   * @param {number} points (optional)
   * @param {number} movesLeft (optional)
   */
  static winBoard(points = 0, movesLeft = 0) {
    if (game.state.current === 'Game') {
      const gameState = game.state.getCurrentState(); // game.js, hopefully
      const gameplayController = G.lvl;
      gameplayController.points = points;
      if (!movesLeft) {
        gameState.board.onBoardDeconstructed.dispatch(); // The old way
        return;
      }

      // The moves left and get points for having so many moves left over!
      if (gameplayController.goalMgr.POINTS) {
        gameplayController.goalMgr.onPointsChange(gameplayController.goalMgr.pointsTarget + 1);
      } else {
        for (let i = 0; i < gameplayController.goalMgr.tasks.length; i++) {
          const t = gameplayController.goalMgr.tasks[i];
          t.uiAnimation = false;
          t.completed = true;
          t.target = 0;
          if (gameplayController.goalMgr.areAllCompleted()) {
            gameplayController.goalMgr.goalAchieved();
          }
        }
      }
      gameState.board.actionManager.removeAction();
    }
  }

  /**
   * lose the current board
   */
  static loseBoard() {
    if (game.state.current === 'Game') {
      G.lvl.moves = 1; // game._gameplayController
      console.log('[CHEAT] You will now lose in one more move');
    }
  }
}
